import React from 'react';
import styled from 'styled-components';

import '../index.css';
function ProductImage(props) {
  const {
    itemImg,
    imgIdx,
    nowIdx,
    itemClick,
    color,
    previewType,
    fontColor,
    fontFamily,
  } = props;

  const imgClick = (idx) => {
    itemClick(idx);
  };

  return (
    <ProductImageContainer
      previewType={previewType}
      itemImg={itemImg}
      color={color}
      onClick={() => imgClick(imgIdx)}
    >
      <img
        alt="상품 이미지"
        src={
          itemImg ??
          'https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/icons/ic-face2.png'
        }
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'scale-down',
          borderRadius: previewType === 'drawer' ? '50%' : '6px',
        }}
      />
      {imgIdx === nowIdx && (
        <div
          style={{
            backgroundColor: '#FF7A00',
            display: 'flex',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '55%',
            height: '27%',
            fontSize: 9,
            borderRadius: 30,
            fontSize: '7.604px',
            fontStyle: 'normal',
            fontWeight: 700,
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            fontFamily: "Noto Sans",
          }}
        >
          NOW
        </div>
      )}
    </ProductImageContainer>
  );
}

export default ProductImage;

const ProductImageContainer = styled.div`
  width: 63px;
  height: 63px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  aspect-ratio: 1/1;
  box-shadow: 0px 2.3px 5.62px 0px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  background-color: ${(props) => (props.itemImg ? 'transparent' : '#D9D9D9')};
  border: ${(props) => (props.itemImg ? `1.7px solid #FF7A00` : 'none')};
  border-radius: ${(props) => (props.previewType === 'drawer' ? '50%' : '6px')};
  height: 85%;
`;
